export default "__VITE_ASSET__vYRohhPL__"